// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__5f6K+","separator":"navbar_separator__DtwMn"};